module.exports = __webpack_public_path__ + "img/icon12.36dd4aac.png";